import { render, staticRenderFns } from "./pageTwo.vue?vue&type=template&id=0a183063&"
import script from "./pageTwo.vue?vue&type=script&lang=js&"
export * from "./pageTwo.vue?vue&type=script&lang=js&"
import style0 from "./pageTwo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports